import {ServerGridModalV3} from "../../../../helpers/modals/ClassBased/ServerGridModalV3";
import {getSingleInputByNameV3, getSingleInputElementByNameV3} from "../../../../helpers/forms/formInputsHelpers";
import {createGrid} from "../../../../helpers/grids/grids";
import {createCellRenderer} from "../../../../helpers/grids/helpers";
import createElement from "../../../../helpers/createElement";
import {waitUntil} from "../../../../helpers/waitUntil";
import Axios from "axios";
import {handleAjaxSuccess} from "../../../../helpers/swalHelper";
import handleAjaxError from "../../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../../helpers/loading";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class ManageContractsModal extends ServerGridModalV3 {
	/** @var {ManageContractsModalDefs.AvailableContractWrapper[]} */
	gridData;
	/** @var {HTMLButtonElement} */
	confirmButton;

	initGridView() {
		// noinspection JSValidateTypes
		this.forRoleSelect = getSingleInputElementByNameV3(this.modalContainer, 'role');

		// Get grid data
		this.gridData = JSON.parse(getSingleInputByNameV3(this.modalContainer, 'gridData'));

		this.gridData.forEach((data, index) => {
			// Default to all checkbox enabled
			data.assignContract = true;
			// Also assign index as id
			data._id = index;
		})

		// Init grid
		// noinspection JSValidateTypes
		this.gridInstance = createGrid(
			this.getGridContainer(),
			{
				columnDefs: [
					{
						field: "typeDisplayName",
						headerName: 'Contract',
						maxWidth: 200,
					},
					{
						field: "public_id",
						headerName: 'Preview',
						maxWidth: 120,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedReference
							return `
								<a
									href="${params.data.previewRoute}"
									target="_blank"
								>
									Preview
									<i class="fa-solid fa-up-right-from-square"></i>
								</a>
							`;
						})
					},
					{
						field: "auditionRequestFullName",
						headerName: 'Name',
					},
					{
						field: "public_id",
						headerName: 'Assign Contract?',
						maxWidth: 160,
						cellClass: 'fill-space',
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							const buttons = createElement(`
								<div class="buttons h-100 d-flex justify-content-center align-items-center">
									<input
										type="checkbox"
										class="form-control assign-contract-checkbox"
										name="assign_contract"
										${params.data.assignContract ? 'checked' : ''}
									>
								</div>`
							)

							const assignContractCheckbox = buttons.querySelector('.assign-contract-checkbox');

							if (assignContractCheckbox) {
								assignContractCheckbox.addEventListener('change', () => {
									this.getActualGridObject(params.data).assignContract = assignContractCheckbox.checked
									this.toggleConfirmButtonStatus();
								})
							}

							return buttons;
						})
					},
				],
				pagination: false,
				cacheBlockSize: 1000,
				paginationPageSize: 1000,
				_rowName: 'Crew',
				onCellDoubleClicked: event => {
					this.getActualGridObject(event.data).assignContract = !this.getActualGridObject(event.data).assignContract;
					this.getGridInstance()._silentRefresh();
					this.toggleConfirmButtonStatus();
				}
			},
			() => this.getGridData(),
		)

		// Add footer button
		waitUntil(() => this.modalContainer.querySelector('.ag-paging-panel[aria-live="polite"]'))
			.then(() => {
				const footer = this.modalContainer.querySelector('.ag-paging-panel[aria-live="polite"]');

				this.confirmButton = createElement('<button class="btn btn-primary position-absolute btn-sm">Assign Contracts<button')

				this.confirmButton.addEventListener('click', () => this.handleAssignContractsRequest());

				// Position absolutely
				// noinspection JSValidateTypes
				this.confirmButton.style = 'left: 4px';

				footer.appendChild(this.confirmButton);

				// Intial render
				this.toggleConfirmButtonStatus();
			})
	}

	/**
	 * @return {import('../../grids/grids').GridInstance}
	 */
	getGridInstance() {
		// noinspection JSValidateTypes
		return this.gridInstance
	}

	getGridData() {
		// Manually setup search filtering
		const search = this.getSearchInput().value.trim().toLowerCase();

		return this.gridData.filter(gridData => {
			if (search) {
				return gridData.auditionRequestFullName.toLowerCase().includes(search) ||
					gridData.typeDisplayName.toLowerCase().includes(search);
			}

			return true;
		})
	}

	/**
	 * Receives the grid params.data object and returns the actual object
	 * to be updated manually
	 *
	 * @return {ManageContractsModalDefs.AvailableContractWrapper}
	 */
	getActualGridObject(paramsData) {
		// noinspection JSUnresolvedReference
		return this.gridData.filter(wrapper => wrapper._id === paramsData._id)[0];
	}

	toggleConfirmButtonStatus() {
		let contractsToAssign = false;

		this.gridData.forEach(wrapper => {
			if (wrapper.assignContract) {
				contractsToAssign = true;
			}
		})

		this.confirmButton.disabled = !contractsToAssign;
	}

	handleAssignContractsRequest() {
		const submitRoute = getSingleInputByNameV3(this.modalContainer, 'submit_route');

		loading();

		Axios.post(submitRoute, {
			contracts: this.gridData.filter(wrapper => {
				return wrapper.assignContract;
			}).map(wrapper => {
				return {
					audition_id: wrapper.auditionRequestId,
					type: wrapper.type,
				}
			})
		})
			.then(response => {
				handleAjaxSuccess(response, () => {
					this.hide();
					this.notifySuccessListeners();
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading);
	}
}

export {ManageContractsModal}

